<template>
  <a-col :span="24" class="setting-content">
    <!-- a-row class="total-content">

      <a-col :xs="24" :sm="24" :md="8" :lg="6" :xl="6" class="total-col">
        <a-card :bordered="false" class="total-item" :bodyStyle="{padding: '12px', textAlign: 'left'}">
          <h3>
            <a-icon type="file-text" class="icon-circle" />
            广告展现次数 
          </h3>
          <p style="text-align: center"> <span> 1234 </span> </p>
        </a-card>
      </a-col>

      <a-col :xs="24" :sm="24" :md="8" :lg="6" :xl="6" class="total-col">
        <a-card :bordered="false" class="total-item" :bodyStyle="{padding: '12px', textAlign: 'left'}">
          <h3>
            <a-icon type="file-text" class="icon-circle" style="background-color: #40a9ff"/>
            广告点击次数 
          </h3>
          <p style="text-align: center"> <span> 1234 </span> </p>
        </a-card>
      </a-col>

      <a-col :xs="24" :sm="24" :md="8" :lg="6" :xl="6" class="total-col">
        <a-card :bordered="false" class="total-item" :bodyStyle="{padding: '12px', textAlign: 'left'}">
          <h3>
            <a-icon type="clock-circle" class="icon-circle" style="background-color:#faad14"/>
            停留时长(分钟) 
          </h3>
          <p style="text-align: center"> <span> 1234 </span> </p>
        </a-card>
      </a-col>

    </a-row -->

    <a-row class="add-ads">
      <a-button type="primary" @click="showAdd">新建推广方案</a-button>
    </a-row>

    <a-modal v-if="deviceType === 'pc'" v-model="addpanel" title="添加推广方案" :footer="null" width="800px" :bodyStyle="autoHeight" style="top: 49px;">
      <ads-editor @success="addSuccess" />
    </a-modal>
    <a-modal v-else v-model="addpanel" :title="null" :footer="null" width="800px" :bodyStyle="autoHeight" style="top: 40px;">
      <ads-editor @success="addSuccess" />
    </a-modal>

    <a-modal v-if="deviceType === 'pc'" v-model="editpanel" title="编辑推广方案" :footer="null" width="800px" :bodyStyle="autoHeight" style="top: 45px;" >
      <ads-editor :item="ads_item" @success="editSuccess" />
    </a-modal>
    <a-modal v-else v-model="editpanel" :title="null" :footer="null" width="800px" :bodyStyle="autoHeight" style="top: 40px;" >
      <ads-editor :item="ads_item" @success="editSuccess" />
    </a-modal>

    <a-modal v-model="showqr" :title="null" :footer="null" width="260px" :bodyStyle="{height: '260px'}">
      <img :src="qrcode"/>
    </a-modal>

    <a-row class="ads-list" :key="refresh">
      <a-col :span="24" v-if="adsList.length > 0">
        <a-row class="ads-list-title">
          <a-col v-if="deviceType === 'pc'">
            <a-col :span="4" style="text-align: left;"><span> 名称 </span></a-col>
            <a-col :span="4" style="text-align: left;"><span> 标语 </span></a-col>
            <a-col :span="4" style="text-align: left;"><span> 联系电话 </span></a-col>
            <a-col :span="4"><span> 图片资料 </span></a-col>
            <a-col :span="4"><span> 操作 </span></a-col>
            <a-col :span="4"></a-col>
          </a-col>
        </a-row>

        <a-row v-for="(ads, index) in adsList" :key="index" class="ads-list-item">
          <a-row v-if="deviceType === 'pc'">
              <a-col :xs="7" :sm="7" :md="4" :lg="4" :xl="4" class="ads-line" style="text-align: left;"> 
                <span> {{ads.title}} </span> 
              </a-col>
              <a-col :xs="7" :sm="7" :md="4" :lg="4" :xl="4" class="ads-line" style="text-align: left;"> 
                <span> {{ads.slogan}} </span> 
              </a-col>
              <a-col :xs="7" :sm="7" :md="4" :lg="4" :xl="4"  class="ads-line" 
                style="text-align: left;">
                <span> {{ads.contact_phone}} </span> 
              </a-col>
              <a-col :xs="10" :sm="10" :md="4" :lg="4" :xl="4"  class="ads-line"> 
                <img :src="BACKEND_API_PREFIX + ads.img.ads" class="list-img"/>
                <img :src="BACKEND_API_PREFIX + ads.img.icon" class="list-img"/>
                <img :src="BACKEND_API_PREFIX + ads.img.qrcode" class="list-img"/>
              </a-col>
              <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="ads-line">
                已生成{{ads.pages}}个推广实例&nbsp; 
                <a style="color: #1890ff" @click="getAdsWeb(ads, index)">
                  <span style="margin-right: 5px;">{{ads.showpages | HideOrShowPages }}</span></a>
                </a>
              </a-col>
              <a-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2" class="ads-line" style="text-align: right;">
                <a style="color: #1890ff" @click="showEdit(ads)"> <a-icon type='edit'/> </a>
                <a-divider type="vertical"/>
                <a-popconfirm title="确认删除吗？" okText="确定" cancelText="取消" @confirm="deleteAds(ads.id, index)">
                  <a style="color: #1890ff" href="#"> <a-icon type='delete'/> </a>
                </a-popconfirm>
              </a-col>
          </a-row>
          <a-row v-else>
              <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" 
                  style="text-align: left; margin-top: 0px;"> 
                  <span style="margin-right: 5px; font-weight: 600;">名称:</span><span>{{ads.title}} </span> 
                </a-col>
                <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" 
                  style="margin-top: 5px;text-align: left;"> 
                  <span style="margin-right: 5px; font-weight: 600;">标语:</span><span>{{ads.slogan}} </span> 
                </a-col>
                <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4"
                  style="text-align: left; margin-top: 5px;"> 
                  <span style="margin-right: 5px; font-weight: 600;">联系电话:</span><span>{{ads.contact_phone}} </span> 
                </a-col>
                <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" 
                  style="text-align: left; margin-top: 5px;">
                  已生成{{ads.pages}}个推广实例
                </a-col>
                <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" 
                  style="text-align: left; margin-top: 5px;">
                  <a style="color: #1890ff" @click="getAdsWeb(ads, index)">
                  <span style="margin-right: 5px;">{{ads.showpages | HideOrShowPages }}</span></a>
                </a-col>
              </a-col>
              <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="margin-top:0px; text-align: right;"> 
                  <a style="color: #1890ff" @click="showEdit(ads)"><a-icon type='edit'/></a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确认删除吗？" okText="确定" cancelText="取消" @confirm="deleteAds(ads.id, index)">
                    <a style="color: #1890ff" href="#"><a-icon type='delete'/></a>
                  </a-popconfirm>
              </a-col>
              <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="text-align: center; margin-top: 5px"> 
                  <a-col :xs="16" :sm="16" :md="4" :lg="4" :xl="4">
                    <img  :src="ads.img.ads" style="width: 80px;height: 100px;"/>
                  </a-col>
                  <a-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4">
                    <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                      <img  :src="ads.img.icon" style="width: 45px;height: 45px;"/>
                    </a-col>
                    <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="margin-top: 10px;">
                      <img  :src="ads.img.qrcode" style="width: 45px;height: 45px;"/>
                    </a-col>
                  </a-col>
              </a-col>
          </a-row>

          <a-col :span="24" v-if="ads.showpages && ads.links.length > 0" class="item-link">
            <a-row v-for="(ls, i) in ads.links" :key="i" style="margin-top: 5px;">
              <a-col :xs="18" :sm="18" :md="18" :lg="20" :xl="20" style="text-align: left;">
                <a :href="'/ads/' + ls.ads_id + '/' + ls.news_id + '.html?prefix=' + BACKEND_API_PREFIX" target="_black">{{ls.title}}</a>
                &nbsp;({{ls.status | StatusChange}})
              </a-col>

              <a-col :xs="6" :sm="6" :md="6" :lg="2" :xl="2" v-if="deviceType === 'pc'" 
                    style="text-align: right;"> {{ls.create_time | TimeChange}}
              </a-col>
              <a-col :xs="6" :sm="6" :md="6" :lg="2" :xl="2" v-if="deviceType === 'pc'" 
                     style="text-align: right;">
                <a style="color: #1890ff" @click="getQrcode(ls)"><a-icon type='qrcode'/></a>
                <a-divider type="vertical" />
                <a style="color: #1890ff" @click="deleteAdsWeb(ls.id, i, ads, index)"><a-icon type='delete'/></a>
              </a-col>

              <a-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" v-if="deviceType === 'mobile'" 
                     style="text-align: right;">
                <a style="color: #1890ff" @click="getQrcode(ls)"><a-icon type='qrcode'/></a>
                <a-divider type="vertical" />
                <a style="color: #1890ff" @click="deleteAdsWeb(ls.id, i, ads, index)"><a-icon type='delete'/></a>
              </a-col>
              <a-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" v-if="deviceType === 'mobile'" 
                    style="text-align: right;">
                {{ls.create_time | TimeChange}}
              </a-col>
            </a-row>
          </a-col>

          <a-col :span="24" v-if="ads.showpages && ads.links.length == 0" class="item-link">
            <a-row style="line-height: 32px;">
              <a> 没有生成任何推广记录 </a>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
      
      <a-col :span="24" v-else="">
        <p>您还没有添加任何推广!</p>
      </a-col>

    </a-row>
  </a-col>
</template>

<script>

import AdsEditor from '@/com/Ads/AdsEditor.vue'

import QRCode from 'qrcode'
import {SHARE_LINK_HOST, BACKEND_API_PREFIX} from '@/util/config'


export default {
  name: 'AdsSetting',
  data() {
    return {
      tab: 'uc,adsp',
      addpanel: false,
      editpanel: false,
      BACKEND_API_PREFIX: BACKEND_API_PREFIX,
      showpreview: false,
      showqr: false,
      qrcode: "",
      previewurl: "",
      adsList: [],
      ads_item: {},
      deviceType: "pc",
      refresh: 1,
      autoHeight: {
        height: '620px'
      }
    }
  },
  components: {
    AdsEditor
  },

  filters: {
    HideOrShowPages(value) { 
        if (!value) 
            return "显示详情"; 
        else
            return "隐藏详情"; 
    }, 
    TimeChange(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + MM + "-" + d;
   },
   StatusChange(value) {
     if (value == 1) {
       return "可用"
     }
     if (value == 0) {
       return "不可用"
     }
     if (value == -1) {
       return "已删"
     }
   }
  },
  methods: {
    showAdd: function() {
      this.addpanel = true
    },
    addSuccess: function(tag) {
      if (tag == 'close') {
        this.addpanel = false
      }
      if (tag == 'refresh') {
        let postdata = {
          task: "SEARCH_TEMPLATE",
          "api-path": "ads"
        }
        let that = this;
        that.post(postdata["api-path"], postdata)
          .then(function(data) {
            if (data.ret == 200) {
              that.adsList = data.data;
              //console.log(JSON.stringify(data.data))
              that.refresh += 1;
            }
          }).catch(function (e) {
        });
      }
    },
    editSuccess: function(tag) {
      if (tag == 'close') {
        this.editpanel = false
      } 
      if (tag == 'refresh') {
        let postdata = {
          task: "SEARCH_TEMPLATE",
          "api-path": "ads"
        }
        let that = this;
        that.post(postdata["api-path"], postdata)
          .then(function(data) {
            if (data.ret == 200) {
              that.adsList = data.data;
              //console.log(JSON.stringify(data.data))
              that.refresh += 1;
            }
          }).catch(function (e) {
        });
      }
    },
    showPreview: function(id) {
      this.showpreview = true
      this.previewurl = "/ads/" + id + "/preview.html";
    },
    showEdit: function(item) {
      this.ads_item = item
      this.editpanel = true
    },

    getQrcode: function(item) {
      let that = this;
      let landing_url = "https://" + SHARE_LINK_HOST + "/ads/" + item.ads_id + "/" + item.news_id + ".html?prefix=" + this.BACKEND_API_PREFIX;
      QRCode.toDataURL(landing_url, function (error, url) {
        if (error)
          console.error(error)
        that.qrcode = url;
        that.showqr = true;
      })
    },
    deleteAdsWeb: function(id, i, item, index) {
      let postdata = {
        id: id,
        task: "DEL_INSTANCE",
        "api-path": "ads"
      }
      let that = this;
      that.post(postdata["api-path"], postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success("删除成功");
            item.links[i]['status'] = -1;
            that.$set(that.adsList, index, item);
          } else {
            that.$message.error("删除失败");
          }
        }).catch(function (e) {
          that.$message.error("删除失败");
      });
    },
    getAdsWeb: function(item, index) {
      if (item.showpages == true) {
        item.showpages = false;
        item.hideorShow = "显示详情";
        this.$set(this.adsList, index, item);
        return;
      }

      if (item.showpages && item.showpages == false) {
        item.showpages = true;
        item.hideorShow = "隐藏详情";
        this.$set(this.adsList, index, item);
        return;
      }
      let postdata = {
        ads_id: item.id,
        task: "SEARCH_INSTANCE",
        "api-path": "ads"
      }
      let that = this;
      that.post(postdata["api-path"], postdata)
        .then(function(data) {
          if (data.ret == 200) {
            item["showpages"] = true;
            item["hideorShow"] = "隐藏详情";
            item["links"] = data.data;
            that.$set(that.adsList, index, item);
          } else {
            that.$message.error("获取失败");
          }
        }).catch(function (e) {
          that.$message.error("获取失败");
      })
    },
    deleteAds: function(id, index) {
      let postdata = {
        id: id,
        task: "DEL_TEMPLATE",
        "api-path": "ads"
      }
      let that = this;
      that.post(postdata["api-path"], postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success("删除成功");
            let list = that.adsList;
            let newlist = [];
            for (let i = 0; i < list.length; i++) {
              if (i != index) {
                newlist.push(list[i]);
              }
            }
            that.adsList = newlist;
          } else {
            that.$message.error("删除失败");
          }
        }).catch(function (e) {
          that.$message.error("删除失败");
      });
    }
  },
  created() {
    this.$store.commit('changetab', this.tab)
    let postdata = {
      task: "SEARCH_TEMPLATE",
      "api-path": "ads"
    }
    let deviceWidth = document.body.clientWidth

    if (deviceWidth <= 870) {
      this.deviceType = 'mobile';
      this.autoHeight = {
        height: '670px'
      }
    }
    else
      this.deviceType = 'pc'; 

    let that = this;
    that.post(postdata["api-path"], postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.adsList = data.data;
        }
      }).catch(function (e) {
    });
  }
}
</script>

<style scoped>
  .setting-content {
    padding: 8px 0px 8px 0px;
    /*border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
    border-bottom: 1px solid #d1d5da;
    border-radius: 0px 0px 3px 3px;*/
  }
  .total-content {
    padding: 8px 4px;
  }
  .total-col {
    margin: 8px;
  }
  .total-item {
    width: 100%;
    background-color: #f5f5f5;
    border-radius: 5px;
  }
  .icon-circle {
    color:white; 
    font-size: 20px; 
    padding: 10px; 
    background-color:#52c41a; 
    border:0px; 
    border-radius: 20px;
  }
  .add-ads {
    padding: 0px 0px;
    text-align: left;
  }
  .ads-list {
    margin-top: 16px;
  }
  .ads-list-title {
    font-size: 13px;
    font-weight: 600;
    padding: 8px;
    border-bottom: 1px solid #d1d5da;
  }
  .list-img {
    width: 32px; 
    height: 32px; 
    margin-right: 4px;
  }
  .ads-list-item {
    padding: 5px;
    border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
    border-bottom: 1px solid #d1d5da;
  }
  .ads-list-item:hover {
    background-color: #e6f7ff;
    cursor: pointer;
  }
  .ads-line {
    line-height: 32px;
    overflow: hidden;
  }
  .item-link {
    border-top: 1px solid #d1d5da;
    margin-top: 8px;
  }
</style>
<style>
  div /deep/.ant-modal-body {
    padding: 12px;
  }
</style>
